module.exports = __webpack_public_path__ + "img/38.80bd8b12.webp";